<script lang="ts">
    import { getContext } from "svelte";
    import type { Readable } from "svelte/store";
    import { DISTANCE_TO_INTERACTIVE } from "../environment";
    import type { CheckpointDistance, Coordinates, Fn } from "../global";
    import type { Route } from "../Model/Route";
    import { distanceCalculator, geolocation } from "../Services";

    const userLocation = geolocation.coords;
    const route: Readable<Route | null> = getContext('route');
    const startRace: Fn = getContext('startRace');
    const isExplorationMode: Readable<boolean> = getContext('isExplorationMode');

    let closeToStartRace = false;

    $: updateStartRaceBtnStatus($userLocation, $route);

    function updateStartRaceBtnStatus(userLocation: Coordinates, route: Route): void {
        
        if (!userLocation || !route) {
            closeToStartRace = false;
            return;
        }

        const checkpointDistances: Array<CheckpointDistance> = [route.firstCheckpoint, route.lastCheckpoint].map(checkpoint => {
            return {
                checkpoint,
                distance: distanceCalculator.calcDistance(checkpoint.coordinates, userLocation),
            };
        });

        checkpointDistances.sort(({ distance: d1 }, { distance: d2 }) => d1 - d2);

        const [closestCheckpointDistance] = checkpointDistances;
        
        closeToStartRace = closestCheckpointDistance.distance < DISTANCE_TO_INTERACTIVE;
    }

</script>

<style lang="scss">

    .start-race-btn {

        img {
            width: 1rem;
            height: 1rem;
        }

    }

</style>
{#if $isExplorationMode}
<button
        style="--grow: 1.1; opacity: {closeToStartRace ? '1' : '0.6'}"
        class="btn start-race-btn"
        class:boing-animation={closeToStartRace}
        type="button"
        disabled={!$userLocation}
        on:click={() => startRace()}>
    <img src="/images/icon-clock.svg" alt="">
    {#if closeToStartRace}
    Empieza la ruta
    {:else}
    Dirígete al inicio
    {/if}
</button>
{/if}